/**
 * AI-ikonet i toppen (B5): åpner «Koble til AI». Ikke et menypunkt — menyrekkefølgen er Atles
 * (navigation.ts) — men en snarvei ved siden av klokka, tegnet som den (Glass 2, §16.5 punkt 1–2).
 *
 * En lenke og ikke en knapp: den går til en side, og skal kunne åpnes i ny fane.
 */
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ICONS } from '@/components/ui/icons';
import { Tooltip } from '@/components/ui/Tooltip';
import { cn } from '@/lib/cn';

export function AiHeaderLink(): ReactNode {
  const { t } = useTranslation();
  const Icon = ICONS.ai;
  return (
    <Tooltip content={t('ai.header.label')} side="bottom">
      <Link
        to="/ai"
        aria-label={t('ai.header.label')}
        data-testid="ai-header-link"
        className={cn(
          'hit-target relative flex size-8 items-center justify-center rounded-full',
          'border border-transparent bg-transparent text-muted ring-focus',
          'hover:bg-[var(--fill-tonal)] hover:text-default',
        )}
      >
        <Icon aria-hidden className="size-4" />
      </Link>
    </Tooltip>
  );
}
